import React from 'react';
import { useEffect } from "react";

import Header from '../components/Header';
import MainSection from '../components/MainSection';
import OverviewSection from '../components/OverviewSection';
import ServicesSection from '../components/ServicesSection';
import PricingSection from '../components/PricingSection';
import FreeTrialContactSection from '../components/FreeTrialContactSection';

import Footer from '../components/Footer';
import ScrollToTopButton from '../components/ScrollToTopButton';
import MobileAppSection from '../components/MobileAppSection';
import WebAppSection from '../components/WebAppSection';
// import FaqSection from '../components/FaqSection';

// import PromotionBadge from '../components/PromotionBadge'; 

export default function LandingPage() {
  useEffect(() => {
    // Evita duplicados en cliente
    if (window.tidioChatApi || document.getElementById('tidio-script')) return;
  
    // 1. Carga el widget
    const s = document.createElement('script');
    s.id   = 'tidio-script';
    s.src  = 'https://code.tidio.co/aswkfhbxam51luq5b6elyf9fnhfcf6al.js';
    s.async = true;
    document.body.appendChild(s);
  
    // 2. Aplica tus estilos cuando el widget esté listo
    function onReady() {
      window.tidioChatApi.adjustStyles('#tidio { bottom:-28px !important; right:0 !important; }');
      window.tidioChatApi.adjustStyles(
        '@media (max-width:980px){ #tidio { bottom:-5px !important; right:-11px !important; } }'
      );
    }
    document.addEventListener('tidioChat-ready', onReady);
  
    // Limpieza (tests, hot-reload, etc.)
    return () => {
      document.removeEventListener('tidioChat-ready', onReady);
      document.body.removeChild(s);
    };
  }, []);

  return (
    <div className="landing-page home">
      <div className="page-wrapper">
        <Header />

        {/* <PromotionBadge /> */}

        <main>
          <MainSection />
          <OverviewSection />
          <ServicesSection />
          <WebAppSection />
          <MobileAppSection />
          <PricingSection />
          <FreeTrialContactSection />
          {/* <FaqSection /> */}
        </main>

        <Footer />
      </div>

      <ScrollToTopButton />
    </div>
  );
}

